import { useEffect, useState } from "react";
import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";
import ReactHelmet from "../../Components/ReactHelmet";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../Core/api";
import Styles from "./ZoomApp.module.css";
import Loading from "../../Components/Loading";

export default function ZoomAccess() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [ZoomUrl, setZoomUrl] = useState("");
  const meetingNumber = query.get("key");
  const passWord = query.get("p");
  const userName = query.get("u");
  const Contact_Id = query.get("id");
  const Class_Id = query.get("cid");
  const Navigate = useNavigate();
  const role = 0;

  const getSignature = async () => {
    try {
      const { data } = await api.post(`/zoom/get-signature/${Contact_Id}`, {
        meetingNumber,
        role,
        Contact_Id,
        Class_Id,
        Demo: false,
      });
      return data.Result;
    } catch (ex) {
      Navigate(
        `/zoom/error/demo?e=${
          ex.response && ex.response.data.Result
            ? ex.response.data.Result
            : ex.message
        }`
      );

      console.log(ex);
    }
  };

  const joinMeeting = async () => {
    const signature = await getSignature();
    let urlZoom = `https://zoom.testifyi.com/meeting.html?name=${userName}&mn=${meetingNumber}&email=&pwd=${passWord}&role=0&lang=en-US&signature=${signature}&china=0&sdkKey=D_0YHlXuQHiE6ocREkIbmQ`;
    setZoomUrl(urlZoom);
    // console.log(signature);

    // await client.init({
    //   zoomAppRoot: meetingSDKElement,
    //   language: "en-US",
    //   patchJsMedia: true,
    //   leaveOnPageUnload: true,
    //   customize: {
    //     video: {
    //       isResizable: true,
    //       viewSizes: {
    //         default: {
    //           width: 1000,
    //           height: 600,
    //         },
    //         ribbon: {
    //           width: 300,
    //           height: 700,
    //         },
    //       },
    //     },
    //   },
    // });
    // await client.join({
    //   signature: signature,
    //   sdkKey: "D_0YHlXuQHiE6ocREkIbmQ",
    //   meetingNumber: meetingNumber,
    //   password: passWord,
    //   userName: userName || "demo",
    //   userEmail: "",
    //   // tk: registrantToken,
    //   // zak: zakToken,

    //   customize: {
    //     // video: {
    //     //   isResizable: true,
    //     //   viewSizes: {
    //     //     default: {
    //     //       width: "100vw",
    //     //       height: "100vh",
    //     //     },
    //     //   },
    //     // },
    //   },
    // });
  };

  useEffect(() => {
    if (meetingNumber && passWord && Class_Id) {
      joinMeeting();
    }
  }, [meetingNumber, passWord, Class_Id]);

  return (
    <>
      <ReactHelmet title={"Zoom Demo Class"} description={""} />
      <Navbar2 />
      {ZoomUrl ? " " : <Loading />}
      <div
        className={Styles.Zoom_Container}
        style={{
          // margin: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {ZoomUrl ? (
          <iframe
            src={ZoomUrl}
            width="100%"
            height={window.innerWidth <= 480 ? "500" : "530"}
            frameborder="0"
            id="zoom-frame"
            allow="microphone; camera;display-capture; fullscreen"
            allowfullscreen
            title="Zoom"
          ></iframe>
        ) : (
          ""
        )}{" "}
      </div>
      <Footer />
    </>
  );
}
